// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"0e5ac90a","239":"c5898ebb","455":"535eb936","809":"b8953c88","853":"285556fd","977":"51f55cf2"}[chunkId] + ".chunk.js";
};